export enum ErrorType {
  // eslint-disable-next-line no-unused-vars
  Error,
  // eslint-disable-next-line no-unused-vars
  Warning,
  // eslint-disable-next-line no-unused-vars
  Information,
  // eslint-disable-next-line no-unused-vars
  Session_Expired,
}
export interface Error {
  errorType: ErrorType;
  errorMessageKey: string;
}
export type localizeType = (n: string, params?: string | string[]) => string;
export type localizeObjectType = (n: string) => object;

export interface ResponseBase {
  tokenExpired?: boolean;
}

export enum Roles {
  // eslint-disable-next-line no-unused-vars
  Call_Center_Associate,
  // eslint-disable-next-line no-unused-vars
  Field_Associate,
}
